<template>
  <div class="app-parner-page">
    <app-nav-page-view :tabHoverPage="3"></app-nav-page-view>
    <div class="app-partner-banner">
      <app-banner-view
        :titleImageBackground="appPartnerBannerImage"
        :titleObj="partnerBannerObj"
      ></app-banner-view>
    </div>
    <app-title-page-view
      :titleObj="CustomerVoiceTitleObj"
    ></app-title-page-view>
    <div class="customer-voice">
      <div>
        系统开发及实施服务快速上线，整合各合作平台后台逻辑
        数据库工程及前端整体页面设计框架均已经有成熟模型，可以据客户实际需
        求修正定制，仅需提供标准接口及接入机制，整上线周期控制在50天。并且提供系
        统层面24小时技术支持，人负责；同时提供灾备功能及订单回传功能，实现整套订单数
        据信息的卡中心共享，为客户后期数据分析及挖掘提供维度支持我们见识到了这支创业团队的
        专业度和专注产品打磨的匠人精神。
      </div>
      <img class="customer-voice-image"
           :src="partnerCustomerVoiceImage" alt="">
    </div>
    <app-title-page-view
      :titleObj="PartCaseTitleObj"
    ></app-title-page-view>
    <ul class="flex-middle-x layout-flex-justify-content_space-between">
      <li v-for="(item,index) in symbiosisList">
        <img :src="item.image" alt="">
      </li>
    </ul>
    <div class="partner-footer">
      <app-footer-page></app-footer-page>
    </div>
  </div>
</template>
<script>
  export default {
    name:'',
    data(){
      return {
        appPartnerBannerImage: require('./image/app-partner-banner-image.png'),
        partnerCustomerVoiceImage: require('./image/partner-customer-voice-image.png'),
        partnerBannerObj:{
          mainHeading:'合作伙伴',
          subhead:'力致打造行业领导者',
          content:'Shanghai golden guarantee network technology co. LTD'
        },
        CustomerVoiceTitleObj:{
          mainHeading:'Customer voice',
          subhead:'客户声音',
          content:''
        },
        PartCaseTitleObj:{
          mainHeading:'Part of the case',
          subhead:'合作伙伴',
          content:'“按需求定制最优框架,提供简单易用操作体验,交付满意服务成果”'
        }
      }
    },
    computed:{
      symbiosisList(){
        return [
          {image:require('./image/pufa.png')},
          {image:require('./image/jtyh.png')},
          {image:require('./image/icbc.png')},
          {image:require('./image/pa.png')},
          {image:require('./image/hx.png')},
          {image:require('./image/ms.png')},
          {image:require('./image/gd.png')},
          {image:require('./image/sh.png')},
          {image:require('./image/bj.png')},
          {image:require('./image/zh.png')},
          {image:require('./image/abc.png')},
          {image:require('./image/jh.png')}
        ]
      }
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped="">
  .app-parner-page{
    .customer-voice{
      width:100%;
      background:$color-4;
      padding:0.2rem 0 0.3rem 0;
      div{
        width:6.9rem;
        height:3.75rem;
        background:url('./image/partner-customer-voice-title.png');
        background-size:100% 100%;
        margin:auto;
        padding:0.3rem;
        font-size:0.24rem;
        color:#555555;
        text-align: left;
      }
      .customer-voice-image{
        width:100%;
        margin-top:0.3rem;
      }
    }
    ul{
      width:100%;
      flex-wrap: wrap;
      background:$color-4;
      padding:0.3rem;
      li{
        width:2.2rem;
        margin-left:0.1rem;
        margin-top:0.05rem;
        img{
          width:100%;
        }
      }
    }
    .partner-footer{
      margin-top:0.3rem;
    }
  }
</style>
